<template>
  <div
    class="quick-manu"
    v-show="judge"
    :style="{ 'z-index': modaldata.Zindex }"
    @mousedown.stop="close1($event)"
  >
    <transition name="slide-left">
      <div class="container" v-show="showQuickManu">
        <li class="quick-manu-list logo">
          <i class="icon menu-icon" @click="close1"></i>
          <!-- <a target="_blank" href="/templates"
            ><img src="../../../static/svg/laihua-logo-light.svg" alt="logo"
          /></a> -->
        </li>
        <li class="quick-manu-list file">
          <i class="icon file-icon"></i>
          <span
            ><a href="/manage" target="_blank" v-analysis="ANALYSIS.manage"
              >作品管理</a
            ></span
          >
        </li>
        <li class="quick-manu-list new">
          <i class="icon new-icon"></i>
          <span @click.stop="addNewDraft" v-analysis="ANALYSIS.create"
            >新建</span
          >
        </li>
        <li class="quick-manu-list template">
          <i class="icon template-icon"></i>
          <span
            ><a
              href="/templates"
              target="_blank"
              v-analysis="ANALYSIS.templates"
              >模板</a
            ></span
          >
        </li>
        <li class="quick-manu-list story">
          <i class="icon story-icon"></i>
          <span
            ><a
              href="/templates?type=1"
              target="_blank"
              v-analysis="ANALYSIS.storybord"
              >故事板</a
            ></span
          >
        </li>
        <li class="quick-manu-list vip">
          <i class="icon vip-icon"></i>
          <span
            ><a href="/workplace/vip" target="_blank" v-analysis="ANALYSIS.vipService"
              >会员服务</a
            ></span
          >
        </li>
        <li class="quick-manu-list toggle-tips">
          <span>新手提示</span>
          <el-tooltip
            effect="dark"
            placement="bottom"
            :open-delay="1000"
            :width="200"
          >
            <div style="width: 200px; font-size: 14px" slot="content">
              开启新手模式，我们会在创作过程中对难度较高的功能进行较为详细的提示。若关闭，则我们会在操作中做较为简要的提示。开启或关闭均不会影响您的创作。
            </div>
            <i class="icon question-icon">?</i>
          </el-tooltip>
          <el-switch
            v-model="showTips"
            active-color="#aba7c2"
            inactive-color="#575075"
            @change="
              $analysis(showTips ? ANALYSIS.openTips : ANALYSIS.closeTips)
            "
          ></el-switch>
        </li>
        <transition name="bounceInLeft">
          <div class="switch-tips-popover" v-show="!known">
            <div class="notice">
              <p class="title">点击这里可以关闭或开启新手提示</p>
              <p class="popover-content">
                （新手提示会在每一步操作时进行较为详细的提示，帮助你快速搞定动画）
              </p>
            </div>
            <div class="bottom-arrow"></div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import modal from "../mixins/modal";
export default {
  mixins: [modal],
  data() {
    return {
      ANALYSIS: {
        manage: {
          category: "editor_navigator",
          action: "click_works_manage",
          label: "编辑器_菜单栏_作品管理",
        },
        create: {
          category: "editor_navigator",
          action: "click_create",
          label: "编辑器_菜单栏_新建",
        },
        templates: {
          category: "editor_navigator",
          action: "click_template",
          label: "编辑器_菜单栏_模板",
        },
        storybord: {
          category: "editor_navigator",
          action: "click_storybord",
          label: "编辑器_菜单栏_故事版",
        },
        vipService: {
          category: "editor_navigator",
          action: "click_vip_service",
          label: "编辑器_菜单栏_会员服务",
        },
        openTips: {
          category: "editor_navigator",
          action: "click_open_tips",
          label: "编辑器_菜单栏_开启新手提示",
        },
        closeTips: {
          category: "editor_navigator",
          action: "click_close_tips",
          label: "编辑器_菜单栏_关闭新手提示",
        },
      },
      modalName: "quickManu",
      showQuickManu: false,
      showTips: true,
      known: true,
    };
  },
  watch: {
    judge(val, oldVal) {
      if (val) {
        this.showQuickManu = true;
      }
    },
    showTips(val, oldVal) {
      this.$bus.emit("switchTips", val);
      if (val) {
        window.localStorage.setItem("showTips", "show");
      } else {
        window.localStorage.setItem("showTips", "hide");
      }
    },
    known(val) {
      if (!val) {
      }
    },
  },
  mounted() {
    if (
      window.localStorage.getItem("showTips") &&
      window.localStorage.getItem("showTips") === "hide"
    ) {
      this.showTips = false;
    } else {
      this.showTips = true;
    }

    this.$bus.on("quickManu-popover", () => {
      this.known = false;
      // 点击其他地方后关闭气泡提示
      document.addEventListener("mouseup", (e) => {
        if (
          e.target.className != "switch-tips-popover" &&
          e.target.className != "notice" &&
          e.target.className != "title" &&
          e.target.className != "popover-content"
        ) {
          this.known = true;
        }
      });
    });
  },
  methods: {
    addNewDraft() {
      this.$http
        .get("/api/user/limit?type=draft")
        .then((res) => {
          console.log("res", res);
          if (res.data.data.exceed) {
            this.$memberGuide({
              show: true,
              context: this,
              funcRight: {
                type: "draftNumber",
                name: "草稿数量",
              },
            });
          } else {
            window.open("/tool", "_blank");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    close1(ev) {
      if (ev.target === ev.currentTarget) {
        this.showQuickManu = false;
        setTimeout(() => {
          this.closeModal();
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss">
.quick-manu {
  .container {
    position: relative;
    width: 220px;
    height: 100%;
    background-color: #474261;
    .quick-manu-list {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
      height: 60px;
      border-top: 2px solid #393451;
      .icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #474261;
        background-color: #fff;
        font-style: normal;
        margin-left: 21px;
      }
      span {
        color: #fff;
        a {
          color: inherit;
          text-decoration: none;
        }
      }
    }
    .logo:hover,
    .file:hover,
    .new:hover,
    .template:hover,
    .story:hover,
    .vip:hover {
      span {
        opacity: 0.7;
      }
    }
    .logo {
      border: none;
      .menu-icon {
        display: inline-block;
        width: 24px;
        height: 27px;
        background-color: #fff;
        cursor: pointer;
        margin-right: 37px;
        background: url("../../../static/svg/menu-white.svg") no-repeat center;
        &:hover {
          background: url("../../../static/svg/menu-active.svg") no-repeat
            center;
        }
      }
      img {
        width: 64px;
        height: 18px;
      }
    }
    .file {
      cursor: pointer;
      .file-icon {
        width: 18px;
        height: 16px;
        background: url("../../../static/svg/works.svg") no-repeat center;
      }
      span {
        margin-left: 41px;
      }
    }
    .new {
      cursor: pointer;
      .new-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: url("../../../static/svg/add-new.svg") no-repeat center;
      }
      span {
        margin-left: 39px;
      }
    }
    .template {
      cursor: pointer;
      .template-icon {
        width: 20px;
        height: 20px;
        background: url("../../../static/svg/template.svg") no-repeat center;
      }
      span {
        margin-left: 39px;
      }
    }
    .story {
      cursor: pointer;
      .story-icon {
        width: 20px;
        height: 18px;
        background: url("../../../static/svg/story.svg") no-repeat center;
      }
      span {
        margin-left: 39px;
      }
    }
    .vip {
      cursor: pointer;
      .vip-icon {
        width: 24px;
        height: 18px;
        font-size: 12px;
        font-weight: bold;
        background: url("../../../static/svg/vip.svg") no-repeat center;
      }
      span {
        margin-left: 35px;
      }
    }
    .toggle-tips {
      position: absolute;
      bottom: 0;
      left: 0;
      span:first-child {
        margin-left: 21px;
      }
      .question-icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        font-style: normal;
        margin-left: 12px;
        margin-right: 49px;
        cursor: pointer;
        &:hover {
          background-color: #8983a5;
        }
      }
      .el-switch__core:after {
        background-color: #8983a5;
      }
      .is-checked {
        .el-switch__core:after {
          background-color: #fff;
        }
      }
    }
    .switch-tips-popover {
      position: absolute;
      bottom: 63px;
      left: 137px;
      width: 280px;
      height: 140px;
      background-color: #fff;
      box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);
      border: solid 1px #dcdaf4;
      border-radius: 8px;
      padding: 25px 34px 20px 30px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .notice {
        text-align: left;
        font-size: 14px;
        color: #474261;
        .title {
          font-weight: bold;
          margin-bottom: 14px;
        }
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 36px;
        background-color: #5778fb;
        border-radius: 8px;
        color: #fff;
        margin-top: 26px;
        cursor: pointer;
      }
      .bottom-arrow {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        bottom: -11px;
        left: 27px;
        margin-bottom: 3px;
        border-width: 11px;
        border-bottom-width: 0;
        border-top-color: #fff;
        &::after {
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          right: -11px;
          bottom: -12px;
          margin-left: -5px;
          border-bottom-width: 0;
          border-top-color: #fff;
          // content: " ";
          border-width: 11px;
        }
      }
    }
  }
}
.slide-left-enter-active {
  transition: all 0.3s linear;
}
.slide-left-leave-active {
  transition: all 0.3s linear;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-left-enter-to,
.slide-left-leave {
  transform: translateX(0);
}

.bounceInLeft-enter-active {
  transition: all 2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.bounceInLeft-leave-active {
  transition: all 1s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.bounceInLeft-enter,
.bounceInLeft-leave-to {
  opacity: 0;
  transform: translate3d(-300px, 0, 0);
}
.bounceInLeft-enter-to,
.bounceInLeft-leave {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

@keyframes bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/quickManu.vue